
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/status",
      function () {
        return require("private-next-pages/status/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/status"])
      });
    }
  